import PageHeader from "@/components/PageHeader";
import { Reveal } from "@/components/Reveal";
import { Check, Phone, Mail, MessageCircle } from "lucide-react";
import { BRAND } from "@/data/catalog";
import QuoteForm from "@/components/QuoteForm";

const POINTS = ["Response within 1 business day", "Low MOQ & bulk pricing", "Free packaging consultation", "Custom branding & printing"];

export default function RequestQuote() {
  return (
    <div data-testid="request-quote-page">
      <PageHeader overline="Request a Quote" title="Tell us your packaging requirement." subtitle="Fill in the details below and our packaging specialists will send you a tailored quotation." />

      <section className="mx-auto max-w-[1400px] px-5 lg:px-10 py-10 grid lg:grid-cols-[1fr_1.3fr] gap-12 items-start">
        <Reveal>
          <div className="rounded-4xl bg-navy text-white p-8 lg:p-10 lg:sticky lg:top-28">
            <h2 className="font-heading text-2xl font-extrabold">Why request a quote?</h2>
            <ul className="mt-6 space-y-3">
              {POINTS.map((p) => (
                <li key={p} className="flex items-center gap-3"><span className="grid place-items-center h-6 w-6 rounded-full bg-emerald text-white shrink-0"><Check size={14} /></span><span className="text-white/85">{p}</span></li>
              ))}
            </ul>
            <div className="mt-8 pt-8 border-t border-white/10 space-y-3 text-sm">
              <a href={`tel:${BRAND.phone.replace(/\s/g, "")}`} className="flex items-center gap-3 text-white/80 hover:text-white"><Phone size={16} /> {BRAND.phone}</a>
              <a href={`mailto:${BRAND.email}`} className="flex items-center gap-3 text-white/80 hover:text-white"><Mail size={16} /> {BRAND.email}</a>
              <a href={`https://wa.me/${BRAND.whatsapp}`} className="flex items-center gap-3 text-white/80 hover:text-white"><MessageCircle size={16} /> WhatsApp us</a>
            </div>
          </div>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="rounded-4xl border border-border bg-card p-8 lg:p-10">
            <QuoteForm />
          </div>
        </Reveal>
      </section>
    </div>
  );
}
